
export const styles = {
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr',
        gap: '16px',
        padding: '16px',
        marginRight: '40px',
    },

    item1: {
        gridColumn: 1,
        gridRow: '1 / span 2', /* spans both rows */
        // background: '#f0f0f0',
        // padding: '16px',
        // border: '1px solid #ccc',
        // borderRadius: '8px',
    },

    item2: {
        gridColumn: '2 / span 2', /* spans columns 2 and 3 */
        gridRow: 1,
        // background: '#e0e0ff',
        // padding: '16px',
        // border: '1px solid #ccc',
        // borderRadius: '8px',
    },

    item3: {
        gridColumn: '2 / span 2', /* spans columns 2 and 3 */
        gridRow: 2,
        // background: '#e0ffe0',
        // padding: '16px',
        // border: '1px solid #ccc',
        // borderRadius: '8px',
    },

    itemTitle: {
        marginTop: 0,
    },

    smallGridContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',

    },
    sg5: {
        gridColumn: '1 / 3',
        gridRow: 3,
    }
};